module.exports = __webpack_public_path__ + "media/icons/left-arrow-white-99fb7bc6.png";